import { Box, Typography, Avatar, Chip } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useAppContext } from "../../../context/appContext";

export default function UserCard({ user, onClick }) {
  const theme = useTheme();
  const { isMobile } = useAppContext();

  const getInitials = (f, l) =>
    f && l ? `${f[0]}${l[0]}` : f?.[0] || l?.[0] || "?";

  // ✅ determine status
  let statusColor = "default";
  let statusLabel = "Inactive";

  if (user.isActive) {
    statusColor = "success";
    statusLabel = "Active";
  } else if (user.isVerified) {
    statusColor = "info";
    statusLabel = "Verified";
  } else {
    statusColor = "warning";
    statusLabel = "Pending";
  }

  return (
    <Box
      onClick={() => onClick?.(user)}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        px: 1.5,
        py: 1,
        borderRadius: 1.5,
        cursor: "pointer",
        backgroundColor: theme.palette.background.default,
        "&:hover": { backgroundColor: theme.palette.action.hover },
      }}
    >
      <Avatar sx={{ width: 32, height: 32, fontSize: "0.85rem" }}>
        {user.abbreviation
          ? user.abbreviation
          : getInitials(user.firstName, user.lastName)}
      </Avatar>

      <Box sx={{ flex: 1 }}>
        <Typography variant="body2" fontWeight="bold">
          {user.firstName} {user.lastName}
        </Typography>

        <Typography variant="caption" color="text.secondary">
          {user.email}
        </Typography>
      </Box>

      {/* ✅ Roles */}
      <Box sx={{ display: "flex", gap: 0.5 }}>
        {user.roles.map((role) => (
          <Chip key={role} label={role} size="small" />
        ))}
      </Box>

      {/* ✅ Status */}
      {!isMobile && (
        <Chip label={statusLabel} color={statusColor} size="small" />
      )}
    </Box>
  );
}
